"use strict";

class Cybersecurity {
    constructor() {}

    init() {
        var slider = tns({
            container: "#canalesCarousel",
            controls: false,
            nav: true,
            slideBy: 1,
            navPosition: "bottom",
            speed: 750,
            mouseDrag: true,
            preventScrollOnTouch: "auto",
            gutter: 30,
            responsive: {
                568: {
                    items: 2,
                },
                768: {
                    items: 3,
                },
                992: {
                    preventActionWhenRunning: true,
                    items: 4,
                },
            },
        });
    }
}

export default Cybersecurity;
